module.exports = __webpack_public_path__ + "media/images/vp/icon.award.gray-d5666c4cc2ab15d33a3deccca1f43bd4.svg";